module.exports = __webpack_public_path__ + "static/media/navyClose2.232bf641.svg";